/* ==========================================================================
   IRON FIT — the plate chooser

   Seven of the eight packages are really two families: the crossover gym in
   20 / 40 / 60 / 80 kg, and the Smith gym in 40 / 60 / 80. On a rack they
   were seven near-identical posters and the only thing separating them was
   small print.

   Each family collapses to one card that opens this: the tiers laid out
   together with the plate weight as the headline, so the only thing that
   actually differs is the thing being chosen between.

   IT LIVES IN ITS OWN FILE because it is needed in two places that share no
   other code — the package rack on the home page, and the machine pages,
   where "see the bundles" now opens the tiers where you stand instead of
   sending you to another page to find them.

   Everything is drawn from window.IFZ_BUNDLES, so prices, savings and plate
   weights cannot drift from the packages themselves.
   ========================================================================== */
(function () {
  'use strict';

  var ALL = window.IFZ_BUNDLES || [];
  var KEY = 'ifz-pk-tier';

  var GROUPS = [
    {
      key: 'famous',
      ids: ['famous', 'famous-40', 'famous-60', 'famous-80'],
      name: 'The Famous Gym',
      badge: 'Choose your plates',
      kicker: 'The Famous Gym',
      title: 'How many plates?',
      lead: 'Same crossover, same bench, same 7 ft bar. The only difference is the weight in the box.',
      layout: 'quad'
    },
    {
      key: 'smith',
      ids: ['smith-starter', 'smith-complete', 'smith-heavy'],
      name: 'The Smith Gym',
      badge: 'Choose your plates',
      kicker: 'The Smith Gym',
      title: 'How many plates?',
      lead: 'Same Smith machine, same bench, same 7 ft bar. The only difference is the weight in the box.',
      layout: 'tri'
    }
  ];

  function byId(id) {
    for (var i = 0; i < ALL.length; i++) if (ALL[i].id === id) return ALL[i];
    return null;
  }

  /* Resolved against what actually exists — a family with one member left is
     not a family and goes back to being an ordinary package. */
  GROUPS.forEach(function (g) { g.tiers = g.ids.map(byId).filter(Boolean); });
  GROUPS = GROUPS.filter(function (g) { return g.tiers.length > 1; });

  function groupFor(id) {
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].ids.indexOf(id) > -1) return GROUPS[i];
    return null;
  }
  function groupByKey(k) {
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].key === k) return GROUPS[i];
    return null;
  }

  /* Which family a machine's packages belong to, for the machine pages. */
  function groupForMachine(machineKey) {
    for (var i = 0; i < GROUPS.length; i++) {
      if (GROUPS[i].tiers.some(function (t) { return t.machine === machineKey; })) return GROUPS[i];
    }
    return null;
  }

  function money(n) {
    return window.IFZCart ? window.IFZCart.money(n) : ('$' + n);
  }

  /* ------------------------------------------------------------------
     The trail back.

     Open a tier and you land on that package's own page. The back arrow
     there returns you to these rather than to the rack — picking a plate
     weight is a decision you are in the middle of, and dropping you a step
     further out means making it again. The key says WHICH family; the X
     clears it, so leaving deliberately leaves properly.
     ------------------------------------------------------------------ */
  function mark(key) { try { sessionStorage.setItem(KEY, key); } catch (e) {} }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function wanted() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }

  var boxes = {};

  function card(t, g) {
    var a = document.createElement('a');
    a.className = 'pkt__card';
    a.href = t.href;
    a.addEventListener('click', function () { mark(g.key); });

    /* The poster whole, not cropped: it is drawn with its own price and
       plate count on it, and a crop threw away the thing being chosen. */
    var media = document.createElement('span');
    media.className = 'pkt__media';
    if (window.IFZPic) media.appendChild(window.IFZPic(t.img, t.plateKg + ' kg of plates'));
    a.appendChild(media);

    var kg = document.createElement('span');
    kg.className = 'pkt__kg';
    kg.innerHTML = '<b>' + (t.plateKg || '') + '</b><em>KG</em>';

    var name = document.createElement('span');
    name.className = 'pkt__name';
    name.textContent = 'of plates';

    var price = document.createElement('span');
    price.className = 'pkt__price';
    price.textContent = money(t.price);

    var save = document.createElement('span');
    save.className = 'pkt__save';
    if (t.was && t.was > t.price) save.textContent = 'Save ' + money(t.was - t.price);

    var go = document.createElement('span');
    go.className = 'pkt__go';
    go.textContent = 'See inside';

    a.appendChild(kg); a.appendChild(name); a.appendChild(price);
    a.appendChild(save); a.appendChild(go);
    return a;
  }

  function build(g) {
    if (boxes[g.key]) return boxes[g.key];

    var box = document.createElement('div');
    box.className = 'pkt pkt--' + g.layout;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', g.kicker + ' — choose how many plates');

    var head = document.createElement('div');
    head.className = 'pkt__head';
    head.innerHTML =
      '<span class="pkt__kicker">' + g.kicker + '</span>' +
      '<h2 class="pkt__title">' + g.title + '</h2>' +
      '<p class="pkt__lead">' + g.lead + '</p>';

    var grid = document.createElement('div');
    grid.className = 'pkt__grid';
    g.tiers.forEach(function (t) { grid.appendChild(card(t, g)); });

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pkt__x';
    x.setAttribute('aria-label', 'Close and see the other packages');
    x.innerHTML = '<span aria-hidden="true">&times;</span>';
    x.addEventListener('click', function () { close(); });
    grid.appendChild(x);

    var foot = document.createElement('p');
    foot.className = 'pkt__foot';
    foot.textContent = 'Close this to go back to the other packages.';

    box.appendChild(head); box.appendChild(grid); box.appendChild(foot);
    document.body.appendChild(box);
    boxes[g.key] = box;
    return box;
  }

  function open(key) {
    var g = groupByKey(key);
    if (!g) return false;
    close(true);                       /* never two choosers at once */
    var box = build(g);

    /* Forcing a reflow rather than waiting for animation frames: a frame
       that never arrives would leave the scroll locked with nothing on
       screen to show for it. */
    document.documentElement.classList.add('pkt-open');
    void box.offsetWidth;
    box.classList.add('is-on');
    return true;
  }

  function close(keepTrail) {
    if (!keepTrail) clear();
    Object.keys(boxes).forEach(function (k) { boxes[k].classList.remove('is-on'); });
    if (!keepTrail) document.documentElement.classList.remove('pkt-open');
  }

  function anyOpen() {
    return Object.keys(boxes).some(function (k) { return boxes[k].classList.contains('is-on'); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && anyOpen()) close();
  });

  window.IFZTiers = {
    groups: function () { return GROUPS; },
    groupFor: groupFor,
    groupByKey: groupByKey,
    groupForMachine: groupForMachine,
    open: open,
    close: close,
    anyOpen: anyOpen,
    wanted: wanted,
    mark: mark,
    clear: clear
  };
})();
